<template>
  <div :class="['container']">
    <div :class="$style.header">
      <h1 :class="[$style.asideColumn, $style.title, 'h3']">{{ t('faq.title') }}</h1>

      <div :class="$style.column">
        <div :class="$style.caption">
          {{ t('faq.text') }}
        </div>

        <UiButton to="https://t.me/zerodetect_support" blank>
          <template #label>
            {{ t('faq.button') }}
          </template>

          <template #preppendIcon>
            <UiIconsArrowTopRight />
          </template>
        </UiButton>
      </div>
    </div>

    <Faq
      :questions
      :categories
      :loading="categoriesStatus"
      v-model="activeCategory"
    />
  </div>

  <Subscribe />
</template>

<script setup lang="ts">
import { eventTracker, AnalyticsEventKey } from '~/utils/analyticServices';

const { locale } = useI18n();
const { t } = useI18n();

useHead({
  title: t('meta.faq.title'),
});


const activeCategory = useState('activeCategory', () => '');

const getCategories = async (): Promise<Record<any, any>[]> => {
  try {
    const response = await fetch(`https://wp.0detect.com/wp-json/custom/v1/faq_category?meta_key=lang&meta_value=${locale.value}`, {
      method: 'GET',
    });
    const jsonResponse = await response.json();
    const excludedIds = [29, 31, 33];
    const output = jsonResponse.filter((item: { term_id: number }) => !excludedIds.includes(item.term_id));
    activeCategory.value = output?.[0]?.term_id || '';

    return output;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const getFAQListByCat = async (cat: string): Promise<Record<any, any>[]> => {
  try {
    const response = await fetch(`https://wp.0detect.com/wp-json/wp/v2/faq?faq_category=${cat}&per_page=40`, {
      method: 'GET',
    });

    return  await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
};

const { data: categories, status: categoriesStatus } = await useAsyncData(
  'faq-categories',
  () => getCategories(),
  {
    watch: [locale],
    server: true,
    lazy: false,
    default: () => [],
  },
);

const { data: questions, status: faqStatus } = await useAsyncData(
  () => getFAQListByCat(activeCategory.value),
  {
    watch: [activeCategory, locale],
    server: true,
    lazy: false,
    default: () => [],
  },
);

onMounted(() => {
  eventTracker(AnalyticsEventKey.FAQPageViewed);
});
</script>

<style lang="scss" module>
  .header {
    display: flex;
    gap: 26px;
    margin-bottom: 35px;

    @media (max-width: 1023px) {
      flex-direction: column;
    }
  }

  .asideColumn {
    flex-shrink: 0;
    @media (min-width: 1024px) {
      width: 34%;
    }
  }

  .column {
    @media (min-width: 1024px) {
      width: 68%;
    }
  }

  .caption {
    max-width: 550px;
    margin-bottom: 23px;
  }
</style>